import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 8px;
  border: 1px solid #d6d7db;
  border-radius: 8px;
  cursor: pointer;
`

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
`

const RecommendationTextContainer = styled.div`
  padding: 0 8px;
  width: 190px;
`

const RecommendationCard = ({ icon, reccomendation, action }) => {
  return (
    <Container>
      <ContentContainer>
        {icon}
        <RecommendationTextContainer>
          <span>{reccomendation}</span>
        </RecommendationTextContainer>
      </ContentContainer>
      {action && <div style={{ display: 'flex', alignSelf: 'flex-end' }}>{action}</div>}
    </Container>
  )
}

export default RecommendationCard
